export default __webpack_public_path__ + "static/media/empty-room-with-windows.dca3ce6a.jpg";